import React, { useContext } from 'react';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { Icon } from '@progress/kendo-react-common';
import TimelineImage from '../../TimelineImage';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';
import { Skeleton } from '@progress/kendo-react-indicators';
import StatusList from '../../ListControls/StatusList';
import { FieldRenderProps } from '@progress/kendo-react-form';
import PriorityList from '../../ListControls/PriorityList';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { ISetStatusProps } from '../../../../types/Ticket/Status/ISetStatusProps';
import { PartialSpinny } from '../../../Nav/Spinny';
import { useNavigate } from 'react-router-dom';
import SLAList from '../../ListControls/SLAList';
import { IPriority } from '../../../../types/Priority/IPriority';
import { ISetPriorityProps } from '../../../../types/Priority/ISetPriorityProps';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import GroupAssigned, { GroupAssignedProps } from './Tools/Close/GroupAssigned';
import { useGetHostConfigQuery } from '../../../../redux/api/AccountApi';
import useRedirectOnClose from '../../../../hooks/useRedirectOnClose';
import { useCloseTicketLogic } from '../../../../hooks/useCloseTicketLogic';

const Timeline: React.FC<ITicketProps> = (ticket) => {
    const navigate = useNavigate();
    const [setStatus, { isLoading: updatingStatus }] = TicketApi.useSetStatusMutation();
    const [setPriority, { isLoading: updatingPriority }] = TicketApi.useSetPriorityMutation();
    const [setSLA, { isLoading: updatingSLA }] = TicketApi.useUpdateSLAMutation();
    const { data: allStatuses } = TicketApi.useGetStatusesQuery();
    const profile = useContext<IUserProfile>(RevUserContext)
    const externalUser = profile?.Features.External_Interface;
    const defaultCloseStatus = allStatuses?.find(s => s.Closed_default === true);
    const [configGroupProps, setConfirmDialogProps] = React.useState<GroupAssignedProps>(null);
    const [setAssigned, { isLoading: settingOwnership }] = TicketApi.useReassignMutation();
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();
    const handleRedirect = useRedirectOnClose();
    const { closeTicket, isClosing } = useCloseTicketLogic(profile);
    const statusChanged = (e) => {
        console.log('statusChanged', e);
        //Ticket closing or Auto Close
        if (e.value.status.Open_status === 0 || e.value.status.Open_status === 4) {
            closeTicket(ticket, e.value.status.ID);
            return;
        }

        //Update the status viua the API
        const props = {
            Ticket_Id: ticket.ID,
            New_Status_Id: e.value.status.ID,
            Auto_Open_Date: e.value?.autoOpenSettings?.Enabled && e.value?.autoOpenSettings?.Auto_Open_Date,
            Auto_Close_Date: e.value?.autoCloseSettings?.Enabled && e.value?.autoCloseSettings?.Auto_Close_Date,
        } as ISetStatusProps

        //Check if there are advanced hierarchy options
        if (profile.Features.Advanced_Heirarchy_Options && ticket.Is_Parent) {
            props.Cascade_To_Children = window.confirm('Do you want to cascade this status change to all children?');
        }

        //Update status via API
        setStatus(props).unwrap().then((hmm) => {

        }).catch((err) => {
            //if the api returns a 400 error them open the validation popup
            if (err.originalStatus === 400) {
                navigate('close');
            }
        })

    };

    const priorityChanged = (e) => {
        console.log('priorityChanged', e);
        const props = {
            Ticket_Id: ticket.ID,
            Priority_Id: e.value.ID,
            Priority_Set_Id: ticket.Priority_Set_Id
        } as ISetPriorityProps
        setPriority(props);
    };

    const SLAChanged = (e) => {
        console.log('slaChanged', e.value?.SLA_ID);
        //if (!e.value?.SLA_ID) return;

        setSLA({ ticketId: ticket.ID, slaID: e.value?.SLA_ID || 0 }).unwrap();
    };

    const selectedPriority = { ID: ticket.Priority_Id, Priority_Level: ticket.Priority_Level } as IPriority;

    const closeClicked = () => {
        //console.log('closeClicked', ticket.CloseValidationCodes, defaultCloseStatus);
        closeTicket(ticket);
    }

    // const closeTicket = (statusId: number) => {
    //     //Check if the ticket is assigned only to a queue - need to show a dialog to confirm assignment to the current user
    //     if (ticket.Call_Assignment.length === 1 && ticket.Call_Assignment[0].Access_Level_Id === 6) {
    //         setConfirmDialogProps({
    //             show: true, onClose: (yes) => {
    //                 //Assign to ME
    //                 if (yes) {
    //                     setAssigned({ TicketId: ticket.ID, New_Assignees: [profile?.Id] }).unwrap().then(() => {
    //                         //Close 
    //                         setConfirmDialogProps(p => { return { ...p, show: false } })

    //                         continueClose(statusId);
    //                     });
    //                 } else {
    //                     setConfirmDialogProps(p => { return { ...p, show: false } })
    //                 }
    //             }
    //         });
    //         return
    //     } else {
    //         //Require Ownership to close FEATURE
    //         if (profile.Features.Require_Ticket_Ownership_To_Close && ticket.Call_Assignment.find(a => a.Contact_Id === profile.Id) === undefined) {
    //             setConfirmDialogProps({
    //                 message: `${profile?.Phrases.CallPhrase} ownership is required. Would you like to assign the ${profile?.Phrases.CallPhrase} to yourself before closing it?`,
    //                 show: true, onClose: (yes) => {
    //                     //Assign to ME
    //                     if (yes) {
    //                         setAssigned({ TicketId: ticket.ID, New_Assignees: [profile?.Id] }).unwrap().then(() => {
    //                             //Close 
    //                             setConfirmDialogProps(p => { return { ...p, show: false } })

    //                             continueClose(statusId);
    //                         });
    //                     } else {
    //                         setConfirmDialogProps(p => { return { ...p, show: false } })
    //                     }
    //                 }
    //             });
    //             return
    //         }
    //     }

    //     continueClose(statusId);
    // }

    // const continueClose = (statusId: number) => {
    //     //if there is no close validation then just close the ticekt otherwise navigate to the close page
    //     if (ticket.CloseValidationCodes.length === 0) {
    //         //DefaULT CLOSE
    //         setStatus({
    //             Ticket_Id: ticket.ID,
    //             New_Status_Id: statusId || defaultCloseStatus?.ID
    //         } as ISetStatusProps).unwrap().then(() => {
    //             //Close the ticket
    //             handleRedirect(ticket?.ID);
    //         }).catch((err) => {
    //             //if the api returns a 400 error them open the validation popup
    //             if (err.originalStatus === 400) {
    //                 navigate(`close/${statusId}`);
    //             }
    //         });

    //         return false;
    //     }

    //     navigate(`close/${statusId}`);
    // }

    return (
        <Card className="timeline">
            <CardHeader>
                <Icon size='large' name='calendar' /> {ticket?.Timeline_Description ? ticket?.Timeline_Description : 'Timeline'}<i></i>
            </CardHeader>
            <CardBody>
                {(updatingPriority || updatingStatus || settingOwnership || updatingSLA || isClosing) && <PartialSpinny />}
                {ticket?.Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '100px', marginTop: '2px' }} />
                    : <>
                        {
                            profile?.Features.External_Interface
                            && <div className='info'><div className='g'>Opened</div><div className='t'> {new Date(ticket.Open_Dt + 'Z').toLocaleString()}</div></div>

                        }
                        <div className='info'>
                            <div className='g'>Status</div>
                            <div className='t'>
                                <div className='status-list'>{externalUser ? ticket.Call_Status :
                                    <div className={`${ticket.Open_Status !== 0 ? 'col-9' : 'col-12'} d-inline-block`}>
                                        <StatusList {...{ onChange: statusChanged } as FieldRenderProps} statusId={ticket.Call_Status_Id} statusName={ticket.Call_Status} statusNameOnly={true} /></div>}
                                    {!externalUser && ticket.Open_Status !== 0 && <div className='col-3 d-inline ms-1'><Button onClick={closeClicked} svgIcon={svg.minusOutlineIcon} title={`Close ${profile?.Phrases.CallPhrase}`}></Button></div>}
                                    {!externalUser && configGroupProps?.show && <GroupAssigned {...configGroupProps} />}
                                </div>
                            </div>
                        </div>

                        {profile.Features.SLAs && <div className='info'><div className='g'>{profile?.Phrases?.SLA}</div><div className='t'> {externalUser ? (ticket.SLA_Name || 'None')
                            :
                            profile.Features.Multi_SLA ? <SLAList {...{ onChange: SLAChanged } as FieldRenderProps} projectId={ticket.Project_Id || 0} priorityId={ticket.Priority_Id || 0} slaId={ticket.SLA_Id || 0} /> : <div className='ms-2'>{ticket.SLA_Name || 'None'}</div>
                        }
                        </div></div>}

                        <div className='info'><div className='g'>{profile?.Phrases?.Priority}</div><div className='t'>{externalUser ? ticket.Priority_Level :
                            <PriorityList {...{
                                onChange: priorityChanged,
                            } as FieldRenderProps} selectedPriority={selectedPriority} prioritySetId={1} priorityChangeHandler={priorityChanged} />}
                        </div></div>
                        {(!profile?.Features.External_Interface || profile?.Features.Show_SSI_Timeline) && <div className='d-flex justify-content-center pt-2'><TimelineImage {...ticket} /></div>}
                    </>
                }
            </CardBody >
        </Card >
    );
};

export default Timeline;